module.exports = __webpack_public_path__ + "static/media/settings.b06670eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/settings.svg
// module id = 1109
// module chunks = 36